// extracted by mini-css-extract-plugin
module.exports = {"tags":"HouseTags_tags__Ov2HR"};